interface IconProps {
  color?: string;
  className?: string;
}

export default function RecorderIcon({ color = "#8E929E", className = "" }: IconProps) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="0.5" y="0.5" width="23.5321" height="23.5321" rx="4.5" stroke={color}/>
      <circle cx="12.266" cy="12.266" r="5.5" fill={color}/>
    </svg>
  );
}
